import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiLoader } = FiIcons;

export default function CityLocalitySelect({
  cities,
  localities,
  selectedCityId,
  selectedLocality,
  onCityChange,
  onLocalityChange,
  citiesLoading,
  localitiesLoading,
  localitiesError,
}) {
  return (
    <div className="space-y-3">
      {/* City Selector */}
      <div className="flex flex-col w-full">
        <label className="mb-1 text-sm font-medium text-gray-700">City</label>
        <select
          className="px-4 py-3 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:outline-none focus:ring-2 focus:ring-brand-gold transition-colors"
          value={selectedCityId}
          onChange={(e) => onCityChange(e.target.value)}
          disabled={citiesLoading}
        >
          <option value="">
            {citiesLoading ? 'Loading cities...' : 'Select City'}
          </option>
          {cities.map((c) => (
            <option key={c.id} value={c.id}>{c.name}</option>
          ))}
        </select>
      </div>

      {/* Locality Selector */}
      <div className="flex flex-col w-full">
        <label className="mb-1 text-sm font-medium text-gray-700">Locality</label>
        <div className="relative">
          <select
            className={`w-full px-4 py-3 rounded-xl border bg-gray-50 focus:bg-white focus:outline-none focus:ring-2 focus:ring-brand-gold transition-colors
              ${localitiesError ? 'border-red-400' : 'border-gray-200'}
              ${localitiesLoading ? 'opacity-60 cursor-not-allowed' : ''}`}
            value={selectedLocality}
            onChange={(e) => onLocalityChange(e.target.value)}
            disabled={!selectedCityId || localitiesLoading}
          >
            <option value="">
              {!selectedCityId
                ? 'Select a city first'
                : localitiesLoading
                ? 'Loading localities...'
                : localities.length === 0
                ? 'No localities found'
                : 'Select Locality'}
            </option>
            {localities.map((l) => (
              <option key={l.id} value={l.name}>{l.name}</option>
            ))}
          </select>
          {localitiesLoading && (
            <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
              <FiLoader className="animate-spin text-brand-gold" />
            </div>
          )}
        </div>
        {localitiesError && (
          <span className="mt-1 text-xs text-red-500 flex items-center gap-1">
            <SafeIcon name="AlertCircle" className="text-xs" />
            {localitiesError}
          </span>
        )}
      </div>
    </div>
  );
}